import Main from '@/main';
import { IProfileQuestionnairesApplication } from './../../interfaces/profile-questionnaires-application.interface.';
import { RenderQuestionnaireIncentiveCommand, RenderQuestionnaireCommand } from 'interfaces/commands';

export class ProfileQuestionnairesApplication implements IProfileQuestionnairesApplication {
	public renderQuestionnaire(command: RenderQuestionnaireCommand): void {
		Main.renderQuestionnaire(
			command.detail.identifier,
			command.detail.showOnRender,
			command.detail.isPopupQuestionnaire,
			command.detail.data,
		);
	}

	public renderIncentive(command: RenderQuestionnaireIncentiveCommand): void {
		Main.renderQuestionnaire(command.detail.identifier, true, false, null);
	}
}
